$(document).bind('_js_ready', function() {
	//var urlSubmit = "";
	var urlSubmit = "";
	$('#quality_form form input').on('change',function(e) {
		e.preventDefault();

		$('#quality_form form input[type="submit"]').prop("disabled", false).removeClass('is-hidden');

		if($('input[value]:checked', '#quality_form').val() == 'Oui'){
		  	$('#comment_txt').prop("disabled", true).prop("required", false);
		  	$('#comment').addClass('is-hidden');
			$('#show_comment_zone').attr("aria-expanded","false");
		}

		if($('input[value]:checked', '#quality_form').val() == 'Non'){
		  	$('#comment_txt').prop("disabled", false).prop("required", true);
		  	$('#comment').removeClass('is-hidden');
			$('#show_comment_zone').attr("aria-expanded","true");
		}
	});
	$('#quality_form form').on('submit',function(e){
		e.preventDefault();
		
		$("#quality_loader").removeClass("display_none");
		$.ajax({
			url: urlSubmit,
			type: 'POST',
			data: $('#quality_form form').serialize()
		})
		.done(function(data) {
			data = JSON.parse(data);
			if(data.success) {
			    $('#quality_form').prop('tabindex', -1).html("<p>Merci pour votre aide !</p>");
			    $('#quality_form').focus();
			}
		});
		return false;
	});
});